import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    imports: []
})
export class ConfirmDialogComponent {
  constructor(public modal: NgbActiveModal) {}

  @Input('messageTitle') messageTitle: any;
  @Input('messageBody') messageBody: any;
  @Input('cancelButton') cancelButton: any;
  @Input('nextButton') nextButton: any;

  closeDialog() {}
}
